export default __webpack_public_path__ + "media/zurb/img/lab/patterntap/pattern-thumb-0fe3f5de273d6baf1de4ed50ebf06dd6.png";